import React, { createContext, useState, useContext, useEffect } from 'react';
import { io } from 'socket.io-client';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [member, setMember] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    const savedToken = localStorage.getItem('token');
    const savedMember = localStorage.getItem('member');
    if (savedToken && savedMember) {
      setToken(savedToken);
      setMember(JSON.parse(savedMember));
    }
    setLoading(false);
  }, []);

  // Connect socket when member logs in
  useEffect(() => {
    if (member && token) {
      const newSocket = io('https://dulimbay-api.trycloudflare.com', {
        transports: ['websocket'],
      });

      newSocket.on('connect', () => {
        console.log('🔌 Socket connected!');
        newSocket.emit('join', member.id);
      });

      // Real-time role change
      newSocket.on('role_changed', (data) => {
        const updatedMember = { ...member, role: data.role };
        setMember(updatedMember);
        localStorage.setItem('member', JSON.stringify(updatedMember));
      });

      // Account approved
      newSocket.on('account_approved', () => {
        const updatedMember = { ...member, status: 'approved' };
        setMember(updatedMember);
        localStorage.setItem('member', JSON.stringify(updatedMember));
      });

      setSocket(newSocket);

      return () => {
        newSocket.disconnect();
      };
    }
  }, [member?.id, token]);

  const login = (token, memberData) => {
    localStorage.setItem('token', token);
    localStorage.setItem('member', JSON.stringify(memberData));
    setToken(token);
    setMember(memberData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('member');
    if (socket) socket.disconnect();
    setToken(null);
    setMember(null);
    setSocket(null);
  };

  return (
    <AuthContext.Provider value={{
      member, token, login, logout,
      loading, socket, setMember
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);